import { CommonModule } from '@angular/common';
import { Component, input, type InputSignal } from '@angular/core';
import type { FileInfo } from '@app/models/document.model';
import { TranslatePipe } from '@ngx-translate/core';
import { AttachmentComponent } from '../attachment/attachment.component';

@Component({
  selector: 'app-attachment-list',
  standalone: true,
  imports: [CommonModule, TranslatePipe, AttachmentComponent],
  templateUrl: './attachment-list.component.html',
  styleUrl: './attachment-list.component.scss',
})
export class AttachmentListComponent {
  readonly files: InputSignal<ReadonlyArray<FileInfo>> =
    input.required<ReadonlyArray<FileInfo>>();
  readonly loading: InputSignal<boolean> = input<boolean>(false);
}
